import Vue from "vue";
import App from "./App.vue";

import VueScrollTo from "vue-scrollto";

// Store
import { store } from "./store/store";
import VueRouter from "vue-router";

// Routes
import { routes } from "./routes/routes";

// Vuetify
import vuetify from "./plugins/vuetify.js";

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
require("./plugins/fontAwesome.js");

Vue.config.productionTip = false;

// Router
Vue.use(VueRouter);

// Scrolling
Vue.use(VueScrollTo, {
  easing: "linear",
  duration: 300,
  offset: -150,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

const router = new VueRouter({
  base: process.env.NODE_ENV === "production" ? "/" : "/",
  routes,
  mode: "hash"
});

Vue.component("font-awesome-icon", FontAwesomeIcon);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
